import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {NgxPaginationModule} from 'ngx-pagination'; // Pagination
import {Ng2OrderModule} from 'ng2-order-pipe'; // importing the module
import {FormsModule} from '@angular/forms';
import {HttpClientModule } from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ReactiveFormsModule} from '@angular/forms';
import {LeftnavComponent} from './web/leftnav/leftnav.component';
import {TopnavComponent} from './web/topnav/topnav.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {OrderModule} from 'ngx-order-pipe';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';


import {LoginComponent} from './web/login/login.component';
import {PrivacyPolicyComponent} from './web/privacy-policy/privacy-policy.component';
import {TermsofuseComponent} from './web/termsofuse/termsofuse.component';
import {CurrencyFormatPipe} from './currency-format.pipe';
import {BarCodeComponent} from './web/leftnav/barcode/bar-code.component';
import { WaterQualityHistoryComponent } from './web/leftnav/Water-quality-Readings-History/water-quality-history.component';
import { WaterQualityComponent } from './web/leftnav/Water-quality-metrics/water-quality.component';

import {ToastNoAnimationModule, ToastrModule} from 'ngx-toastr';
import {environment} from 'src/environments/environment';
import {AsyncPipe, DatePipe} from '@angular/common';

import { BatchEntryDashboardComponent } from './web/leftnav/BatchTransactions/batch-entry-dashboard/batch-entry-dashboard.component';
import { PondTracebilityComponent } from './web/leftnav/Traceability-Report/pond-tracebility.component';

import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {AnalyticsComponent} from './web/leftnav/Charts/analytics/analytics.component';
import {ExcelService} from './services/excelService';
import { GoogleMapsModule } from '@angular/google-maps';
import {HomeComponent} from './home/home.component';
import {
  BatchWaterQualityComponent
} from './web/leftnav/BatchTransactions/batch-water-quality/batch-water-quality.component';
import {
  BatchWaterQualityViewComponent
} from './web/leftnav/BatchTransactions/batch-water-quality-view/batch-water-quality-view.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { FirebaseNotificationsMessagingService } from './services/FirebaseMessaging.service';
import { initializeApp } from "firebase/app";
import { PreviousRouteService } from './services/previousRouteService';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDatepickerModule} from "@angular/material/datepicker";
import { MatRadioModule } from '@angular/material/radio';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CUSTOM_DATE_FORMATS } from './Utils/date-format';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MapDeviceComponent } from './web/leftnav/map-device/map-device.component';
import { LandingpageComponent } from './web/landing-page/landing-page.component';
import { SectionsComponent } from './web/leftnav/sections/sections.component';
import { PondsComponent } from './web/leftnav/ponds/ponds.component';
import { PondCulturesComponent } from './web/leftnav/pond-cultures/pond-cultures.component';
import { LocationComponent } from './web/leftnav/locations/locations.component';
import { AssignDeviceComponent } from './web/leftnav/DMM/assign-device/assign-device.component';
import { AssignDeviceToFarmComponent } from './web/leftnav/DMM/assign-device-to-farm/assign-device-to-farm.component';
import { DeviceComponent } from './web/leftnav/DMM/device/device.component';
import { DeviceHealthComponent } from './web/leftnav/DMM/device-health-monitoring/device-health-monitoring.component';
import { DeviceOnHandComponent } from './web/leftnav/DMM/device-onhand/device-onhand.component';
import { DeviceTrackingComponent } from './web/leftnav/DMM/device-tracking/device-tracking.component';
import { SrStatusCodesComponent } from './web/leftnav/sr-status-codes/sr-status-codes.component';
import { SrTopicsComponent } from './web/leftnav/sr-topics/sr-topics.component';
import { SensorsComponent } from './web/leftnav/sensors/sensors.component';
import { SensorTypesComponent } from './web/leftnav/sensor-types/sensor-types.component';
import { DeviceParametersComponent } from './web/leftnav/device-parameters/device-parameters.component';
import { DeviceModelsComponent } from './web/leftnav/device-models/device-models.component';
import { AutoUpdateComponent } from './web/leftnav/auto-update/auto-update.component';
import { FileDownloadComponent } from './web/leftnav/file-download/file-download.component';
import { FileUploadComponent } from './web/leftnav/file-upload/file-upload.component';
import { IoPortsComponent } from './web/leftnav/io-ports/io-ports.component';
import { WifiComponent } from './web/leftnav/wifi/wifi.component';
import { TestCategoriesComponent } from './web/leftnav/test-configurations/test-categories/test-categories.component';
import { QualityParametersComponent } from './web/leftnav/test-configurations/quality-parameters/quality-parameters.component';
import { QualityParameterTypesComponent } from './web/leftnav/test-configurations/quality-parameter-types/quality-parameter-types.component';
import { QualityParameterRangesComponent } from './web/leftnav/test-configurations/quality-parameter-ranges/quality-parameter-ranges.component';
import { ServiceRequestsComponent } from './web/leftnav/service-requests/service-requests.component';
import { ContinuousMonitoringComponent } from './web/leftnav/continuous-monitoring/continuous-monitoring.component';

initializeApp(environment.firebase);

/**
 * @module AppModule
 * @description
 * The root module of the AquaCloud application. It serves as the central hub for declaring components,
 * importing modules, and providing global services.
 *
 * **Key Responsibilities:**
 * 1. **Application Bootstrap**: Bootstraps the `AppComponent` to launch the application.
 * 2. **Component Declaration**: Registers all application components, including:
 *    - **Admin Panel**: User access, trading community, hardware configuration.
 *    - **Dashboards**: Main dashboard, SME dashboard, provider dashboards.
 *    - **Reports**: Farm summary, water quality, weekly growth, activity trackers.
 *    - **Material Management**: Transactions, batch management, vendor masters.
 * 3. **Module Integration**: Imports core Angular modules and third-party libraries:
 *    - **UI Frameworks**: Angular Material and ngx-bootstrap.
 *    - **Utilities**: Toastr for notifications, Pagination, Ordering.
 *    - **Maps**: Google Maps integration.
 * 4. **Global Configuration**:
 *    - Configures `ToastrModule` with global settings (timeout, progress bar).
 *    - Configures `BsDatepickerModule`.
 *    - Sets up Material Datepicker with Moment.js adapter and custom formats.
 *
 * **Global Services (Providers):**
 * - `FirebaseNotificationsMessagingService`: Manages push notifications.
 * - `ExcelService`: Handles Excel export functionality.
 * - `PreviousRouteService`: Tracks navigation history.
 * - `DatePipe`, `AsyncPipe`: Global pipes.
 *
 * **Initialization Logic:**
 * - Initializes Firebase app with environment configuration.
 * - Dynamically loads Google Maps API script in the constructor.
 *
 * @author AquaCloud Development Team
 * @version 1.0.0
 */
@NgModule({
  declarations: [
    AppComponent,
    LeftnavComponent,
    TopnavComponent,
    WaterQualityComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    TermsofuseComponent,
    CurrencyFormatPipe,
    BarCodeComponent,
    AssignDeviceComponent,
    AssignDeviceToFarmComponent,
    DeviceComponent,
    DeviceHealthComponent,
    DeviceOnHandComponent,
    DeviceTrackingComponent,
    SrTopicsComponent,
    SrStatusCodesComponent,
    AutoUpdateComponent,
    FileDownloadComponent,
    FileUploadComponent,
    IoPortsComponent,
    WifiComponent,
    DeviceModelsComponent,
    DeviceParametersComponent,
    SensorsComponent,
    SensorTypesComponent,
    ServiceRequestsComponent,
    QualityParameterRangesComponent,
    QualityParameterTypesComponent,
    QualityParametersComponent,
    TestCategoriesComponent,
    ContinuousMonitoringComponent,
    WaterQualityHistoryComponent,
    MapDeviceComponent,
    BatchEntryDashboardComponent,
    PondTracebilityComponent,
    AnalyticsComponent,
    HomeComponent,
    BatchWaterQualityComponent,
    BatchWaterQualityViewComponent,
    LandingpageComponent,
    SectionsComponent,
    PondsComponent,
    PondCulturesComponent,
    LocationComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    Ng2OrderModule,
    AutocompleteLibModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    OrderModule,
    ReactiveFormsModule,
    CollapseModule,
    BsDropdownModule,
    TimepickerModule,
    ButtonsModule,
    // IvyCarouselModule
    // AngularDateTimePickerModule
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 2000, // 1 seconds
      progressBar: true,
    }), // ToastrModule added,
    ToastNoAnimationModule.forRoot(),
    GoogleMapsModule,
    NgxMaterialTimepickerModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSlideToggleModule,
    ScrollingModule
  ],
  providers: [FirebaseNotificationsMessagingService, AsyncPipe, ExcelService, PreviousRouteService, DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  /**
   * @constructor
   * @description
   * Initializes the AppModule.
   * Triggers the loading of external scripts required for the application.
   */
  constructor() {
    this.loadGoogleMaps();
  }

  /**
   * @method loadGoogleMaps
   * @description
   * Dynamically appends the Google Maps JavaScript API script to the document head.
   * This is necessary for the `GoogleMapsModule` and related components (e.g., `MapDeviceComponent`) to function.
   *
   * **Implementation Details:**
   * - Creates a `<script>` element.
   * - Sets the `src` attribute with the API key.
   * - Sets `async` and `defer` for performance.
   * - Appends to `document.head`.
   *
   * @returns {void}
   * @side-effect Modifies the DOM by adding a script tag.
   */
  loadGoogleMaps() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBrPSo5L3Y7IVgvKXMJFNPL66uwZp3zQdg`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
